import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { StatusCode } from "api/protocols";


import Form from "components/form/Form";
import FormLayout from "components/form/FormLayout";
import Sheet from "components/sheet/Sheet";
import Search from "components/search/Search";
import Spin from "components/spin/spin";
import Radio from "components/radio/index";
import { GetMembership } from "api/rpc/2024-04/facilityAdmin/membership/membership";
import "./newCustomerMembershipModal.scss";

type NewCustomerMembershipModalProps = {
  children: React.ReactElement<any>;
  applyMembershipToCustomer: (selectedMembershipId: number) => Promise<void>;
  adminType: "facility" | "client";
};

export default function NewCustomerMembershipModal(props: NewCustomerMembershipModalProps) {
  const [state, setState] = useState({
    isOpen: false,
    searchValue: "",
    selectedMembership: null,
  });
  const [searchedMemberships, setSearchedMemberships] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    let mounted = true;

    void loadAllMemberships();

    return () => {
      mounted = false;
    };

    async function loadAllMemberships() {
      // loading spinner while waiting for response
      if (searchedMemberships !== null) {
        setSearchedMemberships(null);
      }
      let res: any;

      //different endpoints
      switch (props.adminType) {
        case "facility":
          res = await GetMembership({ search: state.searchValue, archived: false }, false);
          break;
        case "client":
          // TODO: Add Client Admin GetMembership (all memberships) endpoint
          // res = await GetMembership({ search: state.searchValue }, false);
          break;
      }

      if (res?.status !== StatusCode.OK) {
        setSearchedMemberships([]); //stop loading spinner
        return;
      }

      console.log(res.data); //debug

      if (mounted) {
        setSearchedMemberships(res.data);
      }
    }
  }, [state.searchValue]);

  async function handleApplyMembership() {
    await props.applyMembershipToCustomer(Number(state.selectedMembership.id));
    setState({ ...state, isOpen: false, selectedMembership: null });
  }

  return (
    <>
      {/* Child == modal trigger */}
      {React.cloneElement(props.children, { onClick: () => setState({ ...state, isOpen: true }) })}

      {state.isOpen && (
        <Sheet
          open
          size="medium"
          closable
          title={t("Find a Membership")}
          onCancel={() => setState({ ...state, isOpen: false, selectedMembership: null })}
          onOk={handleApplyMembership}
          cancelText={t("Cancel")}
          okText={t("Apply")}
          okDisabled={state.selectedMembership ? false : true}
        >
          <Form>
            <FormLayout>
              <FormLayout.Group>
                <Search
                  historyKey={"ui-customer-membership"}
                  searchCallback={searchValue =>
                    setState({
                      ...state,
                      searchValue: searchValue,
                      selectedMembership: null,
                    })
                  }
                  placeholder={t("Search for membership...")}
                  inputDisabled={searchedMemberships === null ? true : false} // When API called, input disabled
                />
              </FormLayout.Group>

              <FormLayout.Group>
                {searchedMemberships ? (
                  <Radio.Group
                    name="customer-membership"
                    className="new-customer-membership-radio-group"
                    value={state.selectedMembership?.id ?? null}
                    onChange={(value: number) => {
                      const membership = searchedMemberships.find((item: any) => item.id === value);
                      if (membership) {
                        setState({ ...state, selectedMembership: membership });
                      }
                    }}
                  >
                    {searchedMemberships.map((membership: any, index: number) => {
                      console.log(membership);
                      return (
                        <Radio.Button key={(membership.id as number) + index} value={membership.id} check>
                          <div>
                            <div>
                              <p className="font-bold">{membership.title}</p>
                              <p className="mb-2">{membership.subtitle}</p>
                              <p>
                                <span className="font-medium">{t("Valid until:")} </span>
                                {membership.expiry ? membership.expiry : "N/A"}
                              </p>
                            </div>
                          </div>
                        </Radio.Button>
                      );
                    })}
                  </Radio.Group>
                ) : (
                  <div
                    style={{ height: "114px", justifyContent: "center", alignItems: "center" }}
                  >
                    <Spin />
                  </div>
                )}
              </FormLayout.Group>
            </FormLayout>
          </Form>
        </Sheet>
      )}
    </>
  );
}
